export default function getTimezoneSelectValue(timezoneOptions, timezone) {
  // Traverse through the sub options under each timezone group
  for (const option of timezoneOptions) {
    if (option.text === timezone || option.value === timezone) {
      return option.value;
    }
    const foundSubOption = option.options.find(subOption => subOption.text === timezone || subOption.value === timezone);
    if (foundSubOption) {
      return foundSubOption.value;
    }
  }
  return timezone;
}